var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.company.nome == 'Axerta')?_c('DashboardAxerta'):_c('div',{staticClass:"grid-center"},[_c('div',[_c('h1',[_vm._v("Benvenuto!")])])])}
var staticRenderFns = []

export { render, staticRenderFns }